<template>
  <div class="layout">
    <div class="layout_chidT">办个展</div>
    <van-row class="order-card1-content">
      <div v-for="(item, index) in holdExhData" :key="index">
        <van-col :span="item.colCount" style="padding: 20px 0;">
          <p style="margin-bottom: 6px;">{{ item.name }}</p>
          <h1>
            <count-to :decimals="item.countConfig.decimals" :duration="item.countConfig.duration" :end-val="item.countConfig.endVal" :prefix="item.countConfig.prefix" :separator="item.countConfig.separator" :start-val="item.countConfig.startVal" :suffix="item.countConfig.suffix" />
          </h1>
        </van-col>
      </div>
    </van-row>

    <div class="layout_chidT" style="margin-top: 10px;">办个会</div>
    <van-row class="order-card1-content">
      <div v-for="(item, index) in holdMeetData" :key="index">
        <van-col :span="item.colCount" style="padding: 20px 0;">
          <p style="margin-bottom: 6px;">{{ item.name }}</p>
          <h1>
            <count-to :decimals="item.countConfig.decimals" :duration="item.countConfig.duration" :end-val="item.countConfig.endVal" :prefix="item.countConfig.prefix" :separator="item.countConfig.separator" :start-val="item.countConfig.startVal" :suffix="item.countConfig.suffix" />
          </h1>
        </van-col>
      </div>
    </van-row>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'exhibitonData',
  props: {
    exhibitionData: {
      type: Object,
      default: {},
    },
    meetingData: {
      type: Object,
      default: {},
    },
  },
  watch: {
    exhibitionData: {
      handler(newValue, oldValue) {
        this.holdExhData[0].countConfig.endVal = newValue.holdCount
        this.holdExhData[1].countConfig.endVal = newValue.progressCount
        this.holdExhData[2].countConfig.endVal = newValue.endCount
        this.holdExhData[3].countConfig.endVal = newValue.attendCount
        this.holdExhData[4].countConfig.endVal = newValue.guestCount
        this.holdExhData[5].countConfig.endVal = newValue.signCount
      },
      deep: true,
    },
    meetingData: {
      handler(newValue, oldValue) {
        this.holdMeetData[0].countConfig.endVal = newValue.holdCount
        this.holdMeetData[1].countConfig.endVal = newValue.progressCount
        this.holdMeetData[2].countConfig.endVal = newValue.endCount
        this.holdMeetData[3].countConfig.endVal = newValue.attendCount
        this.holdMeetData[4].countConfig.endVal = newValue.guestCount
        this.holdMeetData[5].countConfig.endVal = newValue.signCount
      },
      deep: true,
    },
  },
  data() {
    return {
      holdExhData: [
        {
          countConfig: {
            startVal: 0,
            endVal: _.random(1000, 6000),
            decimals: 0,
            prefix: '',
            suffix: '场',
            separator: ',',
            duration: 3000,
          },
          name: '累计办展数量',
          colCount: 8,
        },
        {
          countConfig: {
            startVal: 0,
            endVal: _.random(1000, 6000),
            decimals: 0,
            prefix: '',
            suffix: '场',
            separator: ',',
            duration: 3000,
          },
          name: '正在进行的展会',
          colCount: 8,
        },
        {
          countConfig: {
            startVal: 0,
            endVal: _.random(1000, 6000),
            decimals: 0,
            prefix: '',
            suffix: '场',
            separator: ',',
            duration: 3000,
          },
          name: '已结束的展会',
          colCount: 8,
        },
        {
          countConfig: {
            startVal: 0,
            endVal: _.random(1000, 6000),
            decimals: 0,
            prefix: '',
            suffix: '人',
            separator: ',',
            duration: 3000,
          },
          name: '累计报名人数',
          colCount: 12,
        },
        {
          countConfig: {
            startVal: 0,
            endVal: _.random(1000, 6000),
            decimals: 0,
            prefix: '',
            suffix: '人',
            separator: ',',
            duration: 3000,
          },
          name: '累计嘉宾人数',
          colCount: 12,
        },
        {
          countConfig: {
            startVal: 0,
            endVal: _.random(1000, 6000),
            decimals: 0,
            prefix: '',
            suffix: '人',
            separator: ',',
            duration: 3000,
          },
          name: '累计签到人数',
          colCount: 12,
        },
      ],
      //  办个展数据
      holdMeetData: [
        {
          countConfig: {
            startVal: 0,
            endVal: _.random(1000, 6000),
            decimals: 0,
            prefix: '',
            suffix: '场',
            separator: ',',
            duration: 3000,
          },
          name: '累计办会数量',
          colCount: 8,
        },
        {
          countConfig: {
            startVal: 0,
            endVal: _.random(1000, 6000),
            decimals: 0,
            prefix: '',
            suffix: '场',
            separator: ',',
            duration: 3000,
          },
          name: '正在进行的会议',
          colCount: 8,
        },
        {
          countConfig: {
            startVal: 0,
            endVal: _.random(1000, 6000),
            decimals: 0,
            prefix: '',
            suffix: '场',
            separator: ',',
            duration: 3000,
          },
          name: '已结束的会议',
          colCount: 8,
        },
        {
          countConfig: {
            startVal: 0,
            endVal: _.random(1000, 6000),
            decimals: 0,
            prefix: '',
            suffix: '人',
            separator: ',',
            duration: 3000,
          },
          name: '累计报名人数',
          colCount: 12,
        },
        {
          countConfig: {
            startVal: 0,
            endVal: _.random(1000, 6000),
            decimals: 0,
            prefix: '',
            suffix: '人',
            separator: ',',
            duration: 3000,
          },
          name: '累计嘉宾人数',
          colCount: 12,
        },
        {
          countConfig: {
            startVal: 0,
            endVal: _.random(1000, 6000),
            decimals: 0,
            prefix: '',
            suffix: '人',
            separator: ',',
            duration: 3000,
          },
          name: '累计签到人数',
          colCount: 12,
        },
      ],
    }
  },
}
</script>

<style lang="less" scoped>
.layout {
  padding: 10px 20px;
  &_chidT {
    position: relative;
    margin-bottom: 10px;
    padding-left: 10px;
    text-align: left;
    font-size: 14px;
    font-weight: bold;
    color: #333;
    margin-top: 10px;
  }
  &_chidT::after {
    content: '';
    position: absolute;
    width: 4px;
    height: 18px;
    background-color: #05a64c;
    top: 0;
    left: 0px;
  }
}
.order-card1-content {
  background: #f8f8f8;
  border-radius: 10px;
}
</style>